import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

function toWebp(src) {
  const webp = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');
  return webp.replace(/ /g, '%20');
}

function ServiceItem(prop) {
  const src = '../' + prop.photo;

  const card = (
    <div className="service">
      <div className="service-photo">
        <picture>
          <source srcSet={toWebp(src)} type="image/webp" />
          <img
            src={src}
            alt={prop.alt}
            width="500"
            height="350"
            loading="lazy"
            decoding="async"
          />
        </picture>
      </div>
      <h3 className="service-title">{prop.title}</h3>
      <div>{prop.description}</div>
    </div>
  );

  return (
    <Col sm={6} md={4} lg={3}>
      {prop.link
        ? <Link to={prop.link} className="service-link">{card}</Link>
        : card
      }
    </Col>
  );
}

export default ServiceItem;
